import { TabContext } from "@mui/lab";
import { useMountEffect } from "@react-hookz/web";
import React from "react";
import { useQueryLoader } from "react-relay";
import { useSdkContext } from "~/components/contexts";
import { DashboardBadge } from "~/components/dashboard-widget/badge";
import { useIsFirstTimeVisitNotificationPanel } from "~/components/dashboard-widget/badge/hooks";
import { useDashboardMessages } from "./hooks";
var NotificationIcon = function NotificationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.422 18.945c-.625.599-1.432.899-2.422.899-.99 0-1.797-.299-2.422-.899-.521-.494-.847-1.068-.977-1.718h-4.57c-.521 0-.989-.183-1.406-.547A1.742 1.742 0 0 1 0 15.313v-.274l.234-.156a10.134 10.134 0 0 0 3.086-3.868c.703-1.51 1.055-3.163 1.055-4.96 0-1.25.417-2.292 1.25-3.125.651-.521 1.419-.899 2.305-1.133.052-.521.274-.951.664-1.289C8.984.17 9.453 0 10 0c.546 0 1.016.169 1.406.507.384.325.623.789.664 1.29.938.234 1.706.612 2.305 1.133.833.833 1.25 1.875 1.25 3.125 0 1.797.352 3.437 1.055 4.922a10.064 10.064 0 0 0 3.086 3.906l.234.156v.274c0 .494-.208.95-.625 1.367-.417.364-.885.547-1.407.547h-4.57c-.13.651-.456 1.224-.976 1.718Zm-4.102-.859c.443.417 1.016.625 1.72.625h-.001c.651 0 1.211-.196 1.68-.586.416-.443.625-.937.625-1.484v-.547h5.625c.208 0 .429-.091.664-.274.052-.026.117-.117.195-.273-1.38-1.146-2.422-2.513-3.125-4.102-.782-1.64-1.172-3.437-1.172-5.39 0-.938-.299-1.705-.898-2.305-.521-.443-1.25-.768-2.188-.976l-.468-.079v-.781c0-.208-.098-.396-.293-.566A1.016 1.016 0 0 0 10 1.094c-.26 0-.488.084-.684.254-.195.169-.293.357-.293.567v.78l-.468.118c-.912.156-1.641.468-2.188.937-.598.599-.898 1.367-.898 2.305 0 1.953-.391 3.75-1.172 5.39-.703 1.589-1.745 2.956-3.125 4.102a.57.57 0 0 0 .195.273c.174.18.414.278.664.274h5.664v.547c0 .547.209 1.028.625 1.445Z",
    fill: "currentColor"
  }));
};
NotificationIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ReadingHistoryIcon = function ReadingHistoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.418 5.812v4.487l3.523 2.18-.515.897-.129-.086-3.91-2.435V5.811h1.031ZM22 10c0 2.764-.974 5.121-2.921 7.073C17.13 19.025 14.782 20 12.032 20c-2.235 0-4.24-.669-6.016-2.008l-.13-.085.646-.855.128.128c1.548 1.196 3.337 1.795 5.372 1.795 2.463 0 4.568-.876 6.316-2.63 1.747-1.751 2.621-3.867 2.621-6.345 0-2.478-.874-4.595-2.621-6.347-1.748-1.752-3.853-2.628-6.316-2.628-2.464 0-4.57.876-6.317 2.628C3.967 5.405 3.095 7.522 3.095 10c0 .399.056.97.171 1.71l1.847-2.138.774.684-2.965 3.377L0 10.256l.774-.684 1.375 1.582A11.18 11.18 0 0 1 2.062 10c0-2.764.975-5.12 2.923-7.073C6.932.976 9.282 0 12.032 0s5.098.976 7.047 2.927C21.026 4.88 22 7.237 22 10Z",
    fill: "#001246"
  }));
};
ReadingHistoryIcon.defaultProps = {
  width: "22",
  height: "20",
  viewBox: "0 0 22 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { NotificationPanel } from "./notification-panel";
import { query } from "./notification-panel/notification-list";
import { ReadingHistoryPanel } from "./reading-history-panel";
import { useReadingHistoryWithArticle } from "./reading-history-panel/hooks";
import { Container, Content, Footer, Greeting, Header, HeaderContent, Link, Message, StyledTab, StyledTabList, StyledTabPanel, UserName } from "./styles";
export const DashboardDisplay = ({
  beforeHeaderSlot,
  className,
  messageRenders
}) => {
  var _user$username;
  const {
    config,
    handleOpenLoginDialog,
    handleRoutePush,
    handleTrackGA,
    handleTrackGA4,
    user
  } = useSdkContext();
  const [currentTab, setCurrentTab] = React.useState("notification");
  const username = user !== null && user !== void 0 && user.firstname && user !== null && user !== void 0 && user.lastname ? `${user.firstname} ${user.lastname}` : (_user$username = user === null || user === void 0 ? void 0 : user.username) !== null && _user$username !== void 0 ? _user$username : "Guest";
  const renderAccountLink = position => {
    if (!user) {
      return /*#__PURE__*/React.createElement(Link, {
        onClick: () => {
          handleTrackGA({
            action: "Login/Click",
            category: "Login",
            label: ""
          });
          handleOpenLoginDialog({
            destination: window.location.href,
            ga4CustomParameter: {
              trigger_point: "header"
            }
          });
        }
      }, "Sign In / Register");
    }
    return /*#__PURE__*/React.createElement(Link, {
      onClick: () => {
        handleTrackGA({
          action: position === "bottom" ? "My Account/Overlay/My Account (Bottom)" : "My Account/Overlay/My Account",
          category: "My Account",
          label: ""
        });
        const url = new URL(`${config.accounts.host}/settings`);
        url.searchParams.set("destination", window.location.href);
        void handleRoutePush(url.toString());
      },
      "data-qa": "render-account-link"
    }, "My Account");
  };
  const {
    message
  } = useDashboardMessages(messageRenders);
  const [notificationListQuery, loadNotificationListQuery] = useQueryLoader(query);
  useMountEffect(() => {
    loadNotificationListQuery({});
  });
  const {
    state: readingHistoryState
  } = useReadingHistoryWithArticle();
  const {
    setIsFirstTime
  } = useIsFirstTimeVisitNotificationPanel();
  const handleReadHistoryClick = () => {
    handleTrackGA4({
      action: "click",
      category: "readinghistory",
      customized_parameters: {
        action_type: "open",
        article_id: ""
      },
      subcategory: ""
    });
  };
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    "data-qa": "dashboard-display"
  }, /*#__PURE__*/React.createElement(Header, null, beforeHeaderSlot, /*#__PURE__*/React.createElement(HeaderContent, null, /*#__PURE__*/React.createElement(Greeting, null, "Hi, ", /*#__PURE__*/React.createElement(UserName, null, username)), renderAccountLink("top"), /*#__PURE__*/React.createElement(Message, null, message))), /*#__PURE__*/React.createElement(TabContext, {
    value: currentTab
  }, /*#__PURE__*/React.createElement(StyledTabList, {
    variant: "fullWidth",
    onChange: (_, value) => {
      setCurrentTab(value);
    }
  }, /*#__PURE__*/React.createElement(StyledTab, {
    "aria-label": "Notification",
    icon: /*#__PURE__*/React.createElement(DashboardBadge, null, /*#__PURE__*/React.createElement(NotificationIcon, {
      color: "#001246"
    })),
    value: "notification",
    disableRipple: true,
    onClick: () => setIsFirstTime(false)
  }), /*#__PURE__*/React.createElement(StyledTab, {
    "aria-label": "Reading History",
    icon: /*#__PURE__*/React.createElement(ReadingHistoryIcon, {
      color: "#001246"
    }),
    value: "reading-history",
    disableRipple: true,
    onClick: handleReadHistoryClick
  })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(StyledTabPanel, {
    value: "notification"
  }, /*#__PURE__*/React.createElement(NotificationPanel, {
    notificationListQuery: notificationListQuery
  })), /*#__PURE__*/React.createElement(StyledTabPanel, {
    value: "reading-history"
  }, /*#__PURE__*/React.createElement(ReadingHistoryPanel, {
    state: readingHistoryState
  })))), /*#__PURE__*/React.createElement(Footer, null, renderAccountLink("bottom")));
};
DashboardDisplay.displayName = "DashboardDisplay";